<template>
  <swiper :options="swiperOption" ref="mySwiper" style="height: 200px;">
    <!-- slides -->
    <swiper-slide v-for="(attachement, index) in attachementList" :key="index">
      <v-img
        :src="apiURL + 'archive/' + (attachement.archive || []).id"
        contain
        max-height="200"
      />
    </swiper-slide>

    <swiper-slide v-if="attachementList && attachementList.length == 0">
      <div
        class="d-flex flex-column align-center justify-center"
        style="height: 200px;"
      >
        <div>
          <v-img :src="cp_logo" contain height="70"></v-img>
        </div>
        <p class="mt-2 body-1 font-weight-medium secondary--text">
          Galería sin imágenes
        </p>
      </div>
    </swiper-slide>

    <!-- Optional controls -->
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import api from "../../api.js";
import SvgIcon from "../SvgIcon";

export default {
  props: ["editable", "idEvent"],
  components: { SvgIcon },
  data: () => ({
    apiURL: api.baseURL,
    cp_logo: require("@/assets/logo.png"),
    attachementList: [],
    swiperOption: {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        bulletElement: "div",
        bulletClass: "swiper-pagination-bullet",
        /*bulletActiveClass: "primary--text", */
        dynamicBullets: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    }
  }),
  methods: {
    showAttachment: function() {
      this.dialogAttachment = true;
    }
  },
  async mounted() {
    if (!this.idEvent) {
      return;
    }
    try {
      let { data: attachementList } = await this.$http.get("attachement", {
        params: {
          where: {
            event: this.idEvent,
            deleted: false
          }
        }
      });

      this.attachementList.push(...attachementList);
    } catch (err) {
      console(err);
    }
  }
};
</script>

<style>
.swiper-container {
  background: #ffffff;
  color: #363636;
}
.swiper-pagination .swiper-pagination-bullet {
  background: var(--v-primary-base) !important;
  border: 2px solid #78939b;
}
</style>
